import React from 'react';
import DocumentHeaderButton from 'Components/DocumentHeaderButton';

import NavigateIconLeft from 'Assets/images/icons/navigate-icon-left.svg';
import NavigateIconRight from 'Assets/images/icons/navigate-icon-right.svg';

interface ModalHeaderNavigateButtons {
  isPrevAvailable: boolean;
  isNextAvailable: boolean;
  onUndo: () => void;
  onRedo: () => void;
}

const ModalHeaderNavigateButtons = ({
  isPrevAvailable,
  isNextAvailable,
  onUndo,
  onRedo,
}: ModalHeaderNavigateButtons) => (
  <div className="interactModal__header-navigate">
    <DocumentHeaderButton
      onClick={onUndo}
      disabled={!isPrevAvailable}
      priority="navigate"
      icon={NavigateIconLeft}
    >
      <span className="interactModal__header-bar-button-text">Prev</span>
    </DocumentHeaderButton>
    <DocumentHeaderButton
      onClick={onRedo}
      disabled={!isNextAvailable}
      priority="navigate"
      icon={NavigateIconRight}
    >
      <span className="interactModal__header-bar-button-text">Next</span>
    </DocumentHeaderButton>
  </div>
);

export default ModalHeaderNavigateButtons;
